import { trackEvent } from '@fs/zion-analytics'
import { getSessionStorageItem, setSessionStorageItem } from '../../../shared/helpers/sessionStorage'
import scrollToTop from '../../../shared/helpers/scrollToTop'
// in development:
// import { logState } from '../../../shared/helpers/log_State'

const AamInitialState = {
  isLoading: true,
  isGuestUser: false,
  options: {},
  tree: [],
  tileData: [],
  year: '',
  fullName: '',
  firstName: '',
  lastName: '',
  countryCode: '',
  initialTileDataRequested: false,
  isAddTreeFlowShowing: false,
  atfGuestOptionSelected: false,
  guestTree: [],
}

const aamReducer = (state, action) => {
  const change = { ...state }
  switch (action.type) {
    case 'INIT_AAM': {
      Object.assign(change, action.data)
      change.isLoading = false
      const tree = getSessionStorageItem('guestTree')
      change.guestTree = tree ?? []
      if (change.guestTree && change.guestTree.length !== 0 && change.isGuestUser) {
        const personIndex = change.guestTree.findIndex((person) => person.atn === action.data.guestUser.atn)
        if (personIndex === -1) {
          change.guestTree.push(action.data.guestUser)
        }
      }
      trackEvent({ event_name: action.type })
      scrollToTop()
      break
    }
    case 'UPDATE_TILE_DATA': {
      change.year = action.data.year
      change.tileData = action.data.tileData
      change.firstName = action.data.firstName
      change.lastName = action.data.lastName
      break
    }
    case 'UPDATE_ATF_OPTION': {
      change.atfGuestOptionSelected = action.payload.atfGuestOptionSelected
      break
    }
    case 'ADD_GUEST_ANCESTOR': {
      const personIndex = change.guestTree.findIndex((person) => person.atn === action.data.atn)
      if (personIndex === -1) {
        change.guestTree.push(action.data)
      } else {
        change.guestTree.splice(personIndex, 1, action.data)
      }
      setSessionStorageItem({ guestTree: change.guestTree })
      break
    }
    default: {
      console.error(`ERROR: Unhandled action type: ${action.type}`) // eslint-disable-line
    }
  }

  // uncomment the following line during development
  // logState(action, state, change)

  return { ...change }
}

export { AamInitialState, aamReducer }
